import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse, HttpEvent, HttpEventType } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
// SERVICES
import { AlertService } from '@services/notification/alert.service';
import { ResourceTypeService } from '@services/resource-type/resource-type.service';
import { ResourceService } from '@services/resource/resource.service';
// MODELS
import { ResourceType } from '@models/resource-type/ResourceType';
import { Response, DialogClosed } from '@models/response-api/ResponseApi';
import { ResourceUpload } from '@models/resource/Resource';
// EXTEND
import { FormBase } from '@base/FormBase';
import { Progress } from '@base/Progress';
import { CatalogBase } from '@models/catalog/Catalog';
// TODO : TAG GTM
declare var dataLayer: any;
@Component({
	selector: 'app-multimedia-dialog',
	templateUrl: './multimedia-dialog.component.html',
	styleUrls: ['./multimedia-dialog.component.scss'],
})
export class MultimediaDialogComponent extends FormBase implements OnInit, OnDestroy {
	subscription = new Subscription();
	form!: FormGroup;
	resourcesTypes: CatalogBase[] = [];
	resourcesTypesSelected: any[] = [];
	fileName = '';
	progress = 0;
	acceptMultimedia = '';
	cct: string | null = '';
	typeSchool: string | null = '';
	constructor(
		public dialogRef: MatDialogRef<MultimediaDialogComponent>,
		private fb: FormBuilder,
		private resourceTypeService: ResourceTypeService,
		private resourceService: ResourceService,
		private alertService: AlertService,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		super();
		this.acceptMultimedia = this.data?.acceptMultimedia || '';
		this.resourcesTypesSelected = this.data?.resourcesTypes || [];
		this.createForm();
		this.loadResourcesTypes();
	}

	ngOnInit() {
		this.cct = localStorage.getItem('cct');
		this.typeSchool = localStorage.getItem('typeSchool');
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	closeDialog(close: DialogClosed = { success: false }) {
		this.dialogRef.close(close);
	}

	get controls() {
		return this.form.controls;
	}

	createForm() {
		this.form = this.fb.group({
			teacherResourceId: [null, [Validators.required]],
			name: ['', [Validators.required, Validators.maxLength(350)]],
			description: ['', [Validators.required, Validators.maxLength(350)]],
			file: [null, [Validators.required]],
		});
	}

	loadResourcesTypes() {
		this.subscription.add(
			this.resourceTypeService.getAll().subscribe({
				next: (x: Response) => {
					const data = x.data as ResourceType[];
					this.resourcesTypes = data.filter((x) => x.active);
					if (this.resourcesTypesSelected.length) {
						this.resourcesTypes = this.resourcesTypes.filter((x) =>
							this.resourcesTypesSelected.includes(x.id)
						);
					}
				},
				error: (error: HttpErrorResponse) => {
					console.log(error);
					this.alertService.showSmallErrorServer();
				},
			})
		);
	}

	changeFile($event: Event) {
		const file = this.getFile($event);
		if (file) {
			this.controls['file'].setValue(file);
			this.fileName = file.name;
		}
	}

	saveChanges($event: Event) {
		$event.preventDefault();
		this.formSubmitted = true;
		if (this.form.valid) {
			this.uploadResource();
		} else {
			this.alertService.showErrorForm();
		}
	}

	uploadResource() {
		this.subscription.add(
			this.resourceService.add(this.form.value as ResourceUpload).subscribe({
				next: (event: HttpEvent<Response>) => {
					const [complete, progress, resp] = Progress.handleProgress(event);
					this.progress = progress;
					if (complete) {
						const { message, success, data } = resp!;
						if (success) {
							this.alertService.showSmallSuccess(message || 'Recurso creado');
							this.eventGTM();
							this.closeDialog({ success: true, data });
						} else {
							dataLayer.push({
								event: 'error_message', //Static data
								content_group: 'Recursos multimedia', //Dynamic data
								error_messgae_text: message, //Dynamic data
								error_messgae_location: 'Guardar recurso', //Dynamic data
								cct: this.cct, //Dynamic data
								school_type: this.typeSchool,
							});
							this.alertService.showError(message);
						}
					}
				},
				error: (error: HttpErrorResponse) => {
					console.log(error);
					this.alertService.showSmallErrorServer();
				},
			})
		);
	}

	eventGTM() {
		const fileTypeId = this.formControl('teacherResourceId').value;
		const fileType = this.resourcesTypes.find((x) => x.id == fileTypeId);
		dataLayer.push({
			event: 'upload_file',
			upload_file: fileType?.description,
			account_type: fileType?.description,
			cct: this.cct, //Dynamic data
			school_type: this.typeSchool,
		});
	}
}
